import React, { PureComponent } from 'react';
import styled from 'styled-components';

import { NitroText, NitroLoading } from 'nitro-components';

const Loader = styled(NitroLoading)`
  && {
    position: relative;
    margin-top: 20px;
  }
`;

class LoadMoreTiles extends PureComponent {
  componentDidMount() {
    console.log('scrollRef', this.scrollRef);
    if (!this.scrollRef) return;
    this.scrollRef.addEventListener('scroll', () => {
      const { scrollTop, clientHeight, scrollHeight } = this.scrollRef;
      if (scrollTop + clientHeight >= scrollHeight) {
        console.log('load more more more');
      }
    });
  }

  componentWillUnmount() {
    if (this.scrollRef) {
      this.scrollRef.removeEventListener('scroll');
    }
  }

  render() {
    const { children } = this.props;
    return (
      <div
        style={{ overflowY: 'scroll', overflowX: 'visible', height: '800px' }}
        ref={node => (this.scrollRef = node)}
      >
        {children}

        <div>
          <Loader screen={false} size={22} />
        </div>

        <div>
          <NitroText variant="base3" style={{ fontStyle: 'italic' }}>
            No more items
          </NitroText>
        </div>
      </div>
    );
  }
}

export default LoadMoreTiles;



// WEBPACK FOOTER //
// ./src/features/insights/components/fbtdriver/loadmoretile.js